import { createContext, useContext, useState } from "react";

const DimensionalContext = createContext(undefined);

export const useDimension = () => {
    const context = useContext(DimensionalContext);
    if (!context) {
        throw new Error('useDimension must be used within a DimensionalProvider');
    }
    return context;
}

export const DimensionalProvider = ({children}) => {
    const [portfolioDimension, setPortfolioDimension] = useState(true);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const toggleDimension = () => {
        if (!isTransitioning) {
            setPortfolioDimension(prev => !prev);
        }
    }

    return (
        <DimensionalContext.Provider value={{
            portfolioDimension, 
            toggleDimension,
            isTransitioning,
            setIsTransitioning
        }}>
            {children}
        </DimensionalContext.Provider>
    )
}